import {footerNavigation} from "../utilities/navigation.js";

export const footer = (totalResults, resultsPerPage, pageNumber) => {
  const searchTableDivParent = document.getElementById("searchTableDiv")
  const tableFooterDiv = document.createElement("div")
  tableFooterDiv.setAttribute("class", "container d-flex flex-row flex-wrap align-items-baseline justify-content-between")
  tableFooterDiv.setAttribute("id", "tableFooter")

  let page = pageNumber
  let pageDisplaySize = resultsPerPage

  const pageRange = [];
  const pageGroups = [];
  pageGroups.push(0);
  let pageGroupFirstPage = [];
  pageGroupFirstPage.push(0);
  pageGroupFirstPage.push(1);
  const pageGroupLastPage = [];
  pageGroupLastPage.push(0);
  const numPages = Math.ceil(totalResults / pageDisplaySize);
  let numPageButtons = 0
  let pageGroupCtr = 1
  let currentPageGroup = 1
  tableFooterDiv.innerHTML = ""
  for (let i = 1; i <= numPages; i++) {
    numPageButtons ++
    pageRange.push(i);
    pageGroups.push(pageGroupCtr);
    if ((i % 10) === 0){
      pageGroupLastPage.push(i);
      pageGroupFirstPage.push(i + 1);
      pageGroupCtr ++
    }
  }
  currentPageGroup = pageGroups[page]
  let lastPageGroup = pageGroups[pageRange.length]
  if (pageNumber > pageRange.length ){
    pageNumber = 1;
  }

  tableFooterDiv.innerHTML = `
      <div id="pageNumbersInfo">
      </div>
      `
  if (pageRange.length > 1){
    // console.log(pageRange.map)
    tableFooterDiv.innerHTML += `
          <nav id="paginationNumbers">
            <div class="dataTables_paginate">
                <ul class="pagination">
                    <li ${page === 1 ? "class='paginate_button page-item previous hidden'"
                                     : "class='paginate_button page-item previous'"}>
                        <a class="page-link" title="Previous Page"
                           onclick=setPageNumber(${page - 1})
                           tabindex="${0}">Prev Page</a>
                    </li>
                    <li ${currentPageGroup > 1 ? "class='paginate_button page-item previous'"
                                               : "class='paginate_button page-item previous hidden'"}>
                      <a class="page-link pageGroup${pageGroups[1]}"
                         onclick=setPageNumber(1)
                         tabindex="${0}">1</a>
                    </li>
                    <li ${currentPageGroup !== 1 ? "class='paginate_button page-item previous'"
                                                 : "class='paginate_button page-item previous hidden'"}>
                        <a class="page-link" title="Previous Page Group"
                           onclick=setPageNumber(${pageGroupLastPage[currentPageGroup - 1]})
                           tabindex="${0}">...</a>
                    </li>
                    ${pageRange.map((el) =>(
                      `<li ${pageGroups[el] !== currentPageGroup ? "class='page-item hidden'"
                                                                 : page === el ? "class='page-item active'"
                                                                               : "class='page-item'"}">
                            <a class="page-link pageGroup${pageGroups[el]}" onclick=setPageNumber(${el}) tabindex="${0}">${el}</a>
                       </li>`)).join('')}
                      <li ${currentPageGroup < lastPageGroup ? "class='paginate_button page-item previous'"
                                                                   : "class='paginate_button page-item previous hidden'"}>
                        <a class="page-link" title="Next Page Group"
                           onclick=setPageNumber(${pageGroupFirstPage[currentPageGroup + 1]})
                           tabindex="${0}">...</a>
                      </li>
                      <li ${currentPageGroup < lastPageGroup ? "class='paginate_button page-item previous'"
                                                      : "class='paginate_button page-item previous hidden'"}>
                        <a class="page-link pageGroup${pageGroups[pageRange.length]}"
                           onclick=setPageNumber(${pageRange.length})
                           tabindex="${0}">${pageRange.length}</a>
                      </li>
                      <li ${page === pageRange.length ? "class='paginate_button page-item previous hidden'"
                                                  : "class='paginate_button page-item previous'"}>
                          <a class="page-link" title="Next Page"
                             onclick=setPageNumber(${page + 1})
                             tabindex="${0}">Next Page</a>
                      </li>
                </ul>
            </div>
        </nav>
  `
  }

  if(page === 0){
    tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page === 0 ? (page +1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + pageDisplaySize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :  ((page * 10) - 9).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + (page * 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      `
  }else if(page === 1){
    if(totalResults < 10){
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      `
    }else{
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page === 1 || page === 0 ? page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + pageDisplaySize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults :  ((page * 10) - 9).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + (page * 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      `
    }
  }else{
    if((pageGroups.length - 1) !== page){
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${(((page - 1) * pageDisplaySize) + 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "-" + (pageDisplaySize * page).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      `
    }else{
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${((page - 1) * pageDisplaySize) + 1 + "-" + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " of " + totalResults.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      `
    }
  }

  searchTableDivParent.appendChild(tableFooterDiv)

  const pageNumberFocus = document.querySelectorAll('.page-link')
  // footerNavigation(pageNumberFocus, page)
  pageNumberFocus.forEach(element => {
    element.addEventListener('keyup', (event) => {
      if(event.keyCode === 13) {
        const cTarget = Number(event.currentTarget.text)
        if(!isNaN(cTarget)) {
          setPageNumber(cTarget)
        }
        if(isNaN(cTarget)){
          if(event.currentTarget.text === 'Prev Page') {
            setPageNumber(page - 1)
          }
          if(event.currentTarget.text === 'Next Page') {
            setPageNumber(page + 1)
          }
          if(event.currentTarget.text === '...' && event.currentTarget.title === 'Previous Page Group'){
            setPageNumber((currentPageGroup -1) * 10)
          }

          if(event.currentTarget.text === '...' && event.currentTarget.title === 'Next Page Group'){
            setPageNumber(currentPageGroup * 10 + 1)
          }
        }
      }

      if(event.code === 'ArrowLeft'){
        const cTarget = event.currentTarget
        let target =  cTarget.parentElement.previousElementSibling.children[0]
        if(currentPageGroup > 1 && cTarget.innerText === (currentPageGroup * 10 - 9).toString()){
          target= cTarget.parentElement.parentElement.children[2].children[0]
        }
        if(cTarget.text === '...' && cTarget.title === 'Previous Page Group'){
          target= cTarget.parentElement.parentElement.children[1].children[0]
        }

        if(cTarget.text === '...' && cTarget.title === 'Next Page Group'){
          target= cTarget.parentElement.parentElement.children[(currentPageGroup * 10 + 2)].children[0]
        }

        if(currentPageGroup === 1 && (cTarget.innerText === "1")){
          target = cTarget.parentElement.previousElementSibling.previousElementSibling.previousElementSibling.children[0]
        }

        if(currentPageGroup > 1 && (cTarget.innerText === "1")){
          target= cTarget.parentElement.parentElement.children[0].children[0]
        }
        target.focus()
        cTarget.blur()
      }

      if(event.code === 'ArrowRight'){
        const cTarget = event.currentTarget
        let target =  cTarget.parentElement.nextElementSibling.children[0]

        if(cTarget.innerText === (currentPageGroup * 10).toString()){
          const targetLength = cTarget.parentElement.parentElement.children.length
          target = cTarget.parentElement.parentElement.children[targetLength - 3].children[0]
        }
        if(cTarget.innerText === 'Prev Page' && currentPageGroup === 1){
          target = cTarget.parentElement.nextElementSibling.nextElementSibling.nextElementSibling.children[0]
        }

        if(currentPageGroup > 1 && (cTarget.innerText === "...") && cTarget.title === 'Previous Page Group'){
          target= cTarget.parentElement.parentElement.children[(currentPageGroup * 10 - 7)].children[0]
        }

        if(currentPageGroup > 1 && cTarget.text === '...' && cTarget.title === 'Next Page Group'){
          const targetLength = cTarget.parentElement.parentElement.children.length
          target = cTarget.parentElement.parentElement.children[targetLength - 2].children[0]
        }

        target.focus()
        cTarget.blur()
      }
    })

    element.addEventListener('focus', (event) => {
      const cTarget = event.currentTarget
      cTarget.classList.add('active')
    })
    element.addEventListener('blur', (event) => {
      const cTarget = event.currentTarget
      cTarget.classList.remove('active')
    })
  })
}

